import React from 'react';
import classNames from 'classnames';
import { SvgIcon } from '@common/sprites';
import styles from './classes.module.scss';

type CountdownCloseButtonProps = {
  totalDuration: number;
  timeLeft: number;
  size?: number;
  onClose?: () => void;
  className?: string;
};

export const CountdownCloseButton: React.FC<CountdownCloseButtonProps> = ({
  totalDuration,
  timeLeft,
  size = 24,
  onClose,
  className
}) => {
  const radius = size / 2 - 1.5;
  const circumference = 2 * Math.PI * radius;

  const clampedTimeLeft = Math.max(0, Math.min(timeLeft, totalDuration));
  const progress = clampedTimeLeft / totalDuration;
  const offset = circumference * (1 - progress);

  return (
    <div
      className={ classNames(styles.countdownButton, className) }
      style={ { width: size, height: size } }
    >
      <svg className={ styles.circle } width={ size } height={ size }>
        <circle
          className={ styles.circleBackground }
          r={ radius }
          cx={ size / 2 }
          cy={ size / 2 }
        />
        <circle
          className={ styles.circleProgress }
          r={ radius }
          cx={ size / 2 }
          cy={ size / 2 }
          strokeDasharray={ circumference }
          strokeDashoffset={ offset }
        />
      </svg>
      <button type="button" className={ styles.closeButton } onClick={ onClose }>
        <SvgIcon id="close_icon_small" size={ 12 } />
      </button>
    </div>
  );
};
